export default __webpack_public_path__ + "21a39c3926f11afc49a81577e55ff5b8.png";